import { RouterProvider } from "react-router-dom";
import { prexRoute } from "./PrexRoute";
import { ThemeProvider } from "./components/theme-provider";
import "./utils/lang/config"; //i18n

const App = () => {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <RouterProvider router={prexRoute} />
    </ThemeProvider>
  );
};

export default App;
